import React from 'react';
import { Link } from 'react-router-dom';
import getStatus from '../../helpers/status-substatus';

export default ({
    name,
    links,
    city,
    state,
    status,
    subStatus,
    EventReport,
    startDate
}) => {
    let location;
    let groupStatus = getStatus(status, subStatus, EventReport, startDate);

    if (city && state) {
        location = `${city.toLowerCase()}, ${state}`;
    }

    return (
        <Link to={links[0].self} className="search__list-item">
            <span className="search__list-title">{name}</span>

            <span className="search__list-body">
                {groupStatus.status && `Status: ${groupStatus.status}`} <br />
                {groupStatus.subStatus &&
                    `Sub Status: ${groupStatus.subStatus}`}{' '}
                <br />
                <span className="search__location">
                    {location && `Location: ${location}`}
                </span>
            </span>
        </Link>
    );
};



// WEBPACK FOOTER //
// ./src/components/search/search-results.js